import React from "react";
import { Col, Row, Navbar, NavbarBrand, Nav, NavItem } from "reactstrap";
import HenkelLogo from "../../images/henkel.png";
import MahindraLogo from "../../images/mahindralogo.png";
import "./Header.css";

function Header() {
  return (
    // <Navbar expand="md" className="">
      <Row >
        {/* Mahindra Logo */}
        <Col  xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}  className="flex-start">
          <NavbarBrand>
            <img src={MahindraLogo} alt="Mahindra Logo" className="mahindra" />
          </NavbarBrand>
        </Col>

        {/* Title */}
        <Col   xs={8} sm={8} md={8} lg={8} xl={8} xxl={8}  className="text-center heading mt-3">
          <h1 className="heading">DIGILINE - VISUAL ANALYTICS</h1>
        </Col>

        {/* Henkel Logo */}
        <Col  xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className="flex-end text-end mb-3">
          <Nav className="navbar-nav-wrap-secondary-content">
            <NavItem>
              <img src={HenkelLogo} alt="Henkel Logo" className="henkel" />
            </NavItem>
          </Nav>
        </Col>
      </Row>
    // </Navbar>
  );
}

export default Header;
